<div class="modal-header">
  <h4 class="modal-title">Adicionar fluxo</h4>
  <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
</div>

<form [formGroup]="formGroup" (ngSubmit)="createFlow()">
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Nome <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="name" placeholder="ex: Novo atendimento">
      <field-error-component [field]="'name'" [label]="'Nome'" [formGroup]="formGroup"></field-error-component>
    </div>

    <div class="mb-3">
      <label class="form-label">Descrição <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="description"
        placeholder="ex: Novo atendimento para automações">
      <field-error-component [field]="'description'" [label]="'Descrição'" [formGroup]="formGroup"></field-error-component>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" [mat-dialog-close]="true" [disabled]="isLoading">Cancelar</button>
    <button type="submit" class="btn btn-primary" [disabled]="isLoading">
      @if (isLoading) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      }
      {{ isLoading ? 'Salvando...' : 'Salvar' }}
    </button>
  </div>
</form>
